import path from 'path';
import React from 'react';
import { Route, Switch } from 'react-router';
import { Paths } from '~admin/route';
import { RouterTest } from '~admin/view/components/__tests__/components/router.test.component';
import { DropdownTest } from '~admin/view/components/__tests__/components/dropdown.test.component';
import { NotFound } from '~common/components/core/not-found.component';

export const TestBasePaths = {
  components: '/components',
  hooks: '/hooks',
};

export const TestRouter: React.FunctionComponent = () => {
  return (
    <Switch>
      <Route
        exact
        path={path.join(Paths.test, path.join(TestBasePaths.components, '/router'))}
        component={RouterTest}
      />
      <Route
        exact
        path={path.join(Paths.test, path.join(TestBasePaths.components, '/dropdown'))}
        component={DropdownTest}
      />
      <Route component={NotFound} />
    </Switch>
  );
};



// WEBPACK FOOTER //
// ./view/components/__tests__/test-router.component.tsx